<template>
  <container tag="main" app :class="['transition-all', 'duration-300']">
    <container :class="['2xl:max-w-screen-2xl', 'xl:max-w-screen-xl', 'mx-auto', 'mt-6', 'py-10', 'px-8']">
      <slot />
    </container>
  </container>
</template>
<script>
export default {
  name: 'AppMain'
}
</script>



// WEBPACK FOOTER //
// src/components/app-main.vue